<template>
    <section class="container relative">
        <AtomTitle>Мы в цифрах</AtomTitle>
        <div
            class="mt-5 flex items-center justify-between gap-5 max-md:flex-col md:mt-10">
            <InNumbersCard
                v-for="(item, index) in items"
                :key="item.id"
                :gradient="GRADIENTS_BY_INDEX[index]"
                :count="
                    Number(item.title?.replaceAll(' ', '').replaceAll('+', ''))
                "
                :title="index === 2 ? 'лет' : ''"
                :counter-duration="COUNTER_DURATION_BY_INDEX[index]"
                :description="item.short_description"
                :icon="ICONS_BY_INDEX[index]" />
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import InNumbersCard from '~/components/particles/in-numbers/InNumbersCard.vue'
import type {
    IInNumbersItem,
    TInNumbersGradient,
    TInNumbersIcons,
} from '~/components/particles/in-numbers/in-numbers.types'

interface Props {
    items: IInNumbersItem[]
}
defineProps<Props>()

const COUNTER_DURATION_BY_INDEX: number[] = [700, 1200, 1600]
const GRADIENTS_BY_INDEX: TInNumbersGradient[] = [
    'bottom-right',
    'top-right',
    'bottom',
]
const ICONS_BY_INDEX: TInNumbersIcons[] = ['people', 'plus', 'success']
</script>
